import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { LoginRequest } from "../model/login-request";
import { Session } from "../model/session";
import { getCurrentSession } from "../utilities/get-current-session";
import { RootState } from "../../../store/app-store";
import { UserInfo } from "../../core";

interface AuthState {
  session: Session;
  isLoading: boolean;
  error: string | null;
}

// Define the initial state using that type
const initialState: AuthState = {
  session: getCurrentSession(),
  isLoading: false,
  error: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setSession: (state, action: PayloadAction<Session>) => {
      localStorage.setItem("session", JSON.stringify(action.payload));
      state.session = action.payload;
      state.error = null;
    },
    logOut: (state) => {
      localStorage.removeItem("session");
      state.session = null;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export function logIn(request: LoginRequest) {
  return async function logInThunk(dispatch: any, getState: any) {
    try {
      dispatch(setLoading(true));
      dispatch(setError(null));

      const axiosInstance = axios.create({
        baseURL: 'https://tanaapi.pixeladdis.com/api',
        // baseURL: 'http://192.168.239.115:8000/api',
        withCredentials: false,
        withXSRFToken: false,
      }); 

      const userInfo = await axiosInstance.post("/login", {
        email: request.email, 
        password: request.password
      });

      console.log(`userInfo = ${userInfo.data.firstName}`)
      dispatch(setSession({ 
        accessToken: userInfo.data.token, 
        userInfo: {
          'id': 'id',
          'firstName': userInfo.data.firstName,
          'email': userInfo.data.email,       
        } as UserInfo 
      }));
    } catch (error: any) {
      console.error("Login error:", error);
      const errorMessage = error.response?.data?.message || "Failed to login. Please try again.";
      dispatch(setError(errorMessage));
    } finally {
      dispatch(setLoading(false));
    }
  };
}

export const { setSession, logOut, setLoading, setError } = authSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectSession = (state: RootState): Session => state.auth.session;
export const selectIsLoading = (state: RootState): boolean => state.auth.isLoading;
export const selectError = (state: RootState): string | null => state.auth.error;

export const authReducer = authSlice.reducer;
